import axios from 'axios';
import { useEffect, useState } from 'react';

export function useGetSettings() {
  const [userTypes, setUserTypes] = useState([]);
  const [countries, setCountries] = useState([]);
  const [companies, setCompanies] = useState([]);

  const fetchCountry = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/dashboard/all-settings`
      );
      setCountries(response.data.countrys);
      setCompanies(response.data.companys);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCompanyId = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/account/user-types`
      );
      setUserTypes(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  function getCountryId(countryName) {
    const countryId = countries.filter(
      (country) => country.name === countryName
    )[0]?.id;
    return countryId;
  }

  function getCompanyId(companyName) {
    const companyId = companies.filter(
      (company) => company.name === companyName
    )[0]?.id;

    return companyId;
  }

  function getUserTypeId(userType) {
    const countryId = userTypes.filter(
      (country) => country.name === userType
    )[0]?.id;
    return countryId;
  }

  useEffect(() => {
    fetchCountry();
    fetchCompanyId();
  }, []);

  return { countries, companies, getCountryId, getUserTypeId, getCompanyId };
}
